<script setup>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import {ref} from 'vue';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';
  import { Pagination, Navigation } from 'swiper/modules';


  const modules = [Pagination, Navigation];
  const props = defineProps({
    articles: {
      type: Array
    }
  });
  const swiperBreakpoints = ref({

    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  });
</script>
<template>
  <swiper
    :slidesPerView="3"
    :spaceBetween="30"
    :loop="true"
    :pagination="{
      clickable: true,
    }"
    :breakpoints="swiperBreakpoints"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide v-for="article in articles" :key="article.id">
      <div class="card-content">
        <a :href="article.slug">
          <div class="card-image">
            <img class="img-card" :src="article.featured_image" alt="">
          </div>
          <div class="card-text">
            <p>{{article.title}}</p>
          </div>
        </a>
      </div>
    </swiper-slide>
  </swiper>
</template>



<style scoped>

  .mySwiper {
    height: 400px;
    width: 100%;
    .card-content{
      a{
        text-decoration: none;
      }
    }
  }
  .mySwiper :deep(.swiper-pagination-bullet) {

    background: #ccc;
    opacity: 1;
  }


  .mySwiper :deep(.swiper-pagination-bullet-active) {
    background: #999;
  }


  .mySwiper :deep(.swiper-pagination-bullet) {
    width: 10px;
    height: 10px;
    margin: 0 5px;
  }

</style>
